module.exports = __webpack_public_path__ + "static/img/pic_ai_video_3.5e9b206.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic_ai_video_3.gif
// module id = PkAy
// module chunks = 1